import React from "react";
import { CSVLink } from "react-csv";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import searchWhiteIcon from "./Icon.png";
import NavBar from "../NavBar";
import { useState } from "react";
export default function InventoryStockList(props) {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => (x.td5.toString() === e.target.value)));
  };
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Inventory Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Stock List</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Stock List</h2>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="order-list-box" style={{ width: "99%" }}>
          <div id="click-data">
            <p>All Products</p>
            <p>Recently Added</p>
            <p>Recently Removed</p>
          </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
              <input
                type="text"
                placeholder="Search by product ID, product name"
                onChange={(val) => {
                  setCount(
                    IncomingData.filter(
                      (x) =>
                        x.td1.match(val.target.value) ||
                        x.td4.match(val.target.value)
                    )
                  );
                  setFiltr1("");
                }}
              />{" "}
              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select
                name=""
                id=""
                className="order-list-input-right-filters"
                value={filtr1}
                onChange={handleFilter1}
              >
                <option value="" selected>
                  Quantity
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>

              <CSVLink
                data={IncomingData}
                className="supplier-content-input-right-filters"
                style={{ display: "flex", alignItems: "center" }}
              >
                Explore List
                <OpenInNewIcon
                  style={{ fontSize: "16", marginLeft: "5" }}
                ></OpenInNewIcon>
              </CSVLink>
            </div>
          </div>
          <table style={{ textAlign: "center" }}>
            <tr>
              <th>Product ID</th>
              <th>SKU</th>
              <th>Suppliers</th>
              <th>Item Name</th>
              <th>Qty</th>
              <th>Value</th>
              <th>Location</th>
              <th>Reorder Level</th>
              <th>Reorder Days</th>
            </tr>
            {count.length > 0
              ? count.map((val) => {
                  return (
                    <tr>
                      <td>{val.td1}</td>
                      <td>{val.td2}</td>
                      <td>{val.td3}</td>
                      <td>{val.td4}</td>
                      <td>{val.td5}</td>
                      <td>{val.td6}</td>
                      <td>{val.td7}</td>
                      <td>{val.td8}</td>
                      <td>{val.td9}</td>
                    </tr>
                  );
                })
              : IncomingData.map((val) => {
                  return (
                    <tr>
                      <td>{val.td1}</td>
                      <td>{val.td2}</td>
                      <td>{val.td3}</td>
                      <td>{val.td4}</td>
                      <td>{val.td5}</td>
                      <td>{val.td6}</td>
                      <td>{val.td7}</td>
                      <td>{val.td8}</td>
                      <td>{val.td9}</td>
                    </tr>
                  );
                })}
          </table>
        </div>
      </div>
    </>
  );
}
export const IncomingData = [
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 1,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike",
    td5: 2,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Puma air",
    td5: 3,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 5,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF666",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 2,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF555",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 3,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF444",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF1222",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
  {
    td1: "KCVF12L",
    td2: "KCVF12L",
    td3: "John Doe",
    td4: "Nike shoes air zoom for men",
    td5: 15,
    td6: 9995,
    td7: "Warehouse Name",
    td8: 14,
    td9: 14,
  },
];
